import { render, staticRenderFns } from "./InterestFollowUpDelete.vue?vue&type=template&id=47bbdf66&"
import script from "./InterestFollowUpDelete.vue?vue&type=script&lang=js&"
export * from "./InterestFollowUpDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports